import { useQuery } from '@tanstack/react-query';

import { fetchAll } from '../../services/genomes';

const KEY = 'genomes';

export function useGenomes() {
  return useQuery([KEY], () => fetchAll());
}
